module.exports = __webpack_public_path__ + "static/media/IMG_8664.4e993f10.jpg";